import { Pipe, PipeTransform } from '@angular/core';

import { FormSelectOption } from '../form-controls/entities/form-select-option.entity';

/*
 * Returns the global disabled message if it exists, else the specific message (if the option is disabled)
 */
@Pipe({
    name: 'getDisabledMsg',
    standalone: true
})
export class GetDisabledMsgPipe implements PipeTransform {
    transform(option: FormSelectOption<any>, globalMsg?: string): string | undefined {
        return (globalMsg ?? option.disabled) ? option.disabledInfoMsg : '';
    }
}
